import { withText } from './Text';
import { Tiny } from './Text.styles';

const TinyText = withText(Tiny);

TinyText.displayName = 'TinyText';

export { TinyText };
